/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { colors } from '_styles';
import images from '_images';
import { _ } from '_locales';

const UploadContainer = styled.div`
  width: 100%;
  height: 110px;
  position: relative;

  &[disabled] {
    pointer-events: none;
    opacity: 0.5;
  }
`;

const UploaderBox = styled.div`
  width: 100%;
  height: 100%;
  float: left;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

const ImagePreview = styled.img`
  width: 75px !important;
`;

const RemoveButton = styled.button`
  width: 30px;
  height: 30px;
  border: none;
  padding: 0;
  margin: 0;
  position: relative;
  background-image: url(${images.closeIcon});
  background-color: #F07580;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 53%;
  float: left;
  margin: 0px 20px;
  border-radius: 25px;
  cursor: pointer !important;
`;

const Label = styled.button`
  color: ${colors.RC_BLUE};
  font-weight: 500;
  border: none;
  background: none;
  text-decoration: underline;
`;

const Input = styled.input`
  display: none;
  cursor: pointer;
`;

/**
 * This component is for set the uploader feature to the reporter
 *
 * @param {string} picture
 * @param {string} setPicture
 */
const ImageUploader = ({ pictures, setPictures }) => {
  const [image, setImage] = useState('');
  const [preview, setPreview] = useState('');
  const ref = useRef();

  const onDrop = (picture) => {
    setPictures(pictures.concat(picture));
  };

  const imageChangeHandler = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      onDrop(file);
      setImage(file);
      setPreview(reader.result);
    };
    if (file && file.type.match('image.*')) {
      reader.readAsDataURL(file);
    }
  };

  const addImageHandler = (e) => {
    e.preventDefault();

    ref.current.click();
  };

  const removeImage = (e) => {
    e.preventDefault();
    setImage('');
    setPreview('');
    setPictures([]);
  };

  return (
    <UploadContainer>
      <Label
        htmlFor="imageUploader"
        onClick={(e) => addImageHandler(e)}
      >
        {_('help.add_image')}
      </Label>
      <Input
        id="imageUploader"
        ref={ref}
        type="file"
        accept="image/*"
        onChange={imageChangeHandler}
        aria-label="upload an image"
      />

      {
        image !== ''
          ? (
            <UploaderBox>
              <ImagePreview src={preview} alt="uploaded image" />
              <RemoveButton onClick={(e) => removeImage(e)} aria-label="remove the selected item" />
            </UploaderBox>
          )
          : null
      }
    </UploadContainer>
  );
};

export default ImageUploader;
